import pulse from "@finn-no/pulse-sdk";

type TrendingHomeTrackingData = {
	id: string;
	name: string;
	position: string;
	url: string;
};

export function trackTrendingHomeClick(home: TrendingHomeTrackingData) {
	pulse.trackEvent({
		type: "Click",
		intent: "Open",
		name: "Popular home clicked",
		object: {
			id: "qasa-popular-ad-card",
			type: "UIElement",
			elementType: "Link",
			name: "Popular home",
			position: home.position,
		},
		target: {
			id: home.id,
			type: "ExternalContent",
			contentId: home.id,
			name: home.name,
			provider: "Qasa.se",
			url: home.url,
		},
		vertical: {
			name: "realestate",
			subVertical: "lettings",
		},
	});
}
